var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81522 1.60907C11.0488 -0.536354 14.1442 -0.53636 15.3779 1.60907L24.7613 17.9281C25.9912 20.067 24.4472 22.7357 21.98 22.7357H3.2131C0.745844 22.7357 -0.798082 20.067 0.431777 17.9281L9.81522 1.60907ZM13.8608 2.48139C13.3 1.5062 11.893 1.5062 11.3323 2.4814L1.94886 18.8004C1.38984 19.7726 2.09162 20.9857 3.2131 20.9857H21.98C23.1015 20.9857 23.8032 19.7726 23.2442 18.8004L13.8608 2.48139Z",
    fill: "#D07200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5965 6.98569C13.0798 6.98569 13.4715 7.37744 13.4715 7.86069V12.5274C13.4715 13.0106 13.0798 13.4024 12.5965 13.4024C12.1133 13.4024 11.7215 13.0106 11.7215 12.5274V7.86069C11.7215 7.37744 12.1133 6.98569 12.5965 6.98569Z",
    fill: "#D07200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1936 16.5423C13.5527 16.8656 13.5819 17.4189 13.2586 17.7781L13.2469 17.791C12.9236 18.1502 12.3704 18.1793 12.0112 17.8561C11.652 17.5328 11.6229 16.9795 11.9462 16.6203L11.9578 16.6074C12.2811 16.2482 12.8344 16.2191 13.1936 16.5423Z",
    fill: "#D07200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.bf732fbbfaf9a257c0b6b8d8327020d0.svg";
export { ForwardRef as ReactComponent };